import { useOutletContext } from 'react-router-dom'
import { SaldoFolha } from 'service/api/endpoints/integracao-folha'

export function useFolhaPagamentoOutletContext() {
    return useOutletContext<{
        data?: SaldoFolha[]
        competencia: string
    }>()
}
